export const ERR_COMMUNICATION=100
export const ERR_UNKNOWN=999


// WEBPACK FOOTER //
// ./src/constants/errors.js